import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Stars from "./Stars";

const YotpoStarRatings = styled.div`
  width: 100%;
  margin-bottom: 0.25rem;
`;

const StarContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
  align-content: center;

  svg {
    margin-top: 2px;
  }
`;

const AverageScore = styled.div`
  color: ${({ theme }) => theme.themeColors.darkGreen1};
  font-size: 16px;
`;

const ReviewNumber = styled.div`
  color: ${({ theme }) => theme.themeColors.darkGreen4};
  font-size: 14px;
  font-weight: 400;
  margin-top: 2px;
`;

function YotpoStarRatingsWidget({ averageYotpoScore, totalYotpoReviews }) {
  return (
    <YotpoStarRatings>
      {totalYotpoReviews > 0 ? (
        <StarContainer>
          <AverageScore>{averageYotpoScore}</AverageScore>
          <Stars score={averageYotpoScore} />
          <ReviewNumber>{totalYotpoReviews} Reviews</ReviewNumber>
        </StarContainer>
      ) : (
        <StarContainer>
          <Stars score={0} />
          <ReviewNumber>No reviews yet</ReviewNumber>
        </StarContainer>
      )}
    </YotpoStarRatings>
  );
}

export default YotpoStarRatingsWidget;

YotpoStarRatingsWidget.propTypes = {
  averageYotpoScore: PropTypes.string,
  totalYotpoReviews: PropTypes.number,
};

YotpoStarRatingsWidget.defaultProps = {
  averageYotpoScore: null,
  totalYotpoReviews: null,
};
